import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["id", "title", "children", "submenu"];
import styled, { css } from 'styled-components';
import { useTheme } from 'foundations-theming-specialty/utils';
import { MenuItemWithSubmenu } from './MenuItemWithSubmenu';
import { MenuPickerTitle } from './MenuPickerTitle';
import memoWithDisplayName from '../../../utils/memoWithDisplayName';
import { getAccountMenuBorder, getAccountMenuItemPadding } from '../../Accounts/shared-styles';
import { getTypographyStyles } from 'breadcrumbs-ui/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledSubmenuItem = styled(MenuItemWithSubmenu)(({
  theme: _theme
}) => {
  const theme = _theme;
  return css(["list-style-type:none !important;border-bottom:", " !important;position:relative;button{position:relative;background-color:transparent;max-width:290px;color:", " !important;border:0;margin:0;width:100%;padding:", ";display:block;text-decoration:none;text-align:left;", " &:hover{background-color:", ";}}"], getAccountMenuBorder(theme), theme.color['text-core-default'], getAccountMenuItemPadding(theme), getTypographyStyles(theme, 'heading-50'), theme.color['fill-secondary-subtle']);
});
export const MenuPicker = memoWithDisplayName('MenuPicker', _ref => {
  let {
      id,
      title,
      children,
      submenu
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const menuContainerStyles = css(["position:absolute;right:300px;background-color:", ";z-index:1;border:", " !important;padding:", " !important;max-width:350px;min-width:200px;width:min-content !important;overflow-y:auto;overflow-x:hidden;list-style-type:none;margin:", ";max-height:235px;top:-1px;@media screen and (max-width:1024px){position:relative;right:0;top:0;border:0 !important;box-shadow:inset 0 11px 8px -10px #ccc,inset 0 -11px 8px -10px #ccc;display:block;border-bottom:", ";width:100% !important;max-height:350px;}"], theme.color['fill-surface-default'], getAccountMenuBorder(theme), theme.space[0], theme.space[0], theme.borderWidth[100]);
  return /*#__PURE__*/_jsxs(StyledSubmenuItem, Object.assign({
    id: id,
    menuContainerStyles: menuContainerStyles,
    enableOnMouseEnterLeaveActions: true,
    submenu: submenu
  }, rest, {
    children: [title ? /*#__PURE__*/_jsx(MenuPickerTitle, {
      title: title
    }) : null, children]
  }));
});